// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ee3d239c3e0286cdc0ce","453":"9950b910bd244773400a"}[chunkId] + ".js";
};